import Promotion from './promotion';
import PromotionDetail from './promotion-detail';
export default Promotion;
export {PromotionDetail};
